// Importing the necessary modules
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// Function to modify category images and icons
(() => {
  const categoryImages = document.querySelectorAll('.horizontal-nav > ul.hasSubmenus > li > ul > li:not(.menu-banner):not(.menu-icon) > a img');
  if (!categoryImages.length > 0) return;

  categoryImages.forEach((image) => {
    const findMore = document.createElement('span');
    findMore.innerHTML = 'Find out more <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 24 24" viewBox="-3.45 -3.45 30.9 30.9" width="9" height="9"><path d="m12 21.4 9.4-9.4L12 2.6M2.6 12h18.8" style="fill:none;stroke:#6d6d6e;stroke-width:5;stroke-linecap:round;stroke-linejoin:round"></path></svg>';
    findMore.classList.add('more');

    const shopNow = document.createElement('span');
    shopNow.innerHTML = 'Shop Now <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 24 24" viewBox="-3.45 -3.45 30.9 30.9" width="9" height="9"><path d="m12 21.4 9.4-9.4L12 2.6M2.6 12h18.8" style="fill:none;stroke:#6d6d6e;stroke-width:5;stroke-linecap:round;stroke-linejoin:round"></path></svg>';
    shopNow.classList.add('more');

    if (image.parentElement.parentElement.classList.contains('js-category-change-text')) {
      image.insertAdjacentElement('afterend', shopNow);
    } else {
      image.insertAdjacentElement('afterend', findMore);
    }

    const name = image.getAttribute('title');
    const title = document.createElement('h4');
    title.innerHTML = name;
    image.insertAdjacentElement('afterend', title);
  });

  const categoryIcons = document.querySelectorAll('.horizontal-nav > ul.hasSubmenus > li > ul > li.menu-icon > a img');
  if (!categoryIcons.length > 0) return;

  categoryIcons.forEach((icon) => {
    const name = icon.getAttribute('title');
    const title = document.createElement('h5');
    title.innerHTML = name;
    icon.insertAdjacentElement('afterend', title);
  });
})();

/**
 * move main category icons to the top of the category
 */
(() => {
  const mainCategoryIcons = document.querySelectorAll('.cd-dropdown-content .cd-secondary-dropdown li.menu-icon');
  if (!mainCategoryIcons.length > 0) return;

  mainCategoryIcons.forEach((icon) => {
    const placement = icon.parentNode.previousElementSibling;
    const img = icon.querySelector('img');
    icon.remove();
    placement.insertAdjacentElement('afterbegin', img);
  });
})();

// Function to handle horizontal categories
(() => {
  const horizontalCategories = document.querySelectorAll('.horizontal-nav > ul.hasSubmenus > li.wide-menu > ul');
  if (!horizontalCategories) return;

  horizontalCategories.forEach((category) => {
    const subCategories = category.querySelectorAll(':scope > li:not(.menu-banner)');
    if (subCategories.length > 6) {
      const categorySlider = document.createElement('li');
      categorySlider.classList.add('category-slider', 'splide');
      categorySlider.ariaLabel = 'category slider';
      const categorySliderTrack = document.createElement('div');
      categorySliderTrack.classList.add('splide__track');
      const categorySliderList = document.createElement('div');
      categorySliderList.classList.add('splide__list');

      subCategories.forEach((subCategory) => {
        const categorySliderItem = document.createElement('div');
        categorySliderItem.classList.add('splide__slide');
        categorySliderItem.appendChild(subCategory);
        categorySliderList.appendChild(categorySliderItem);
      });

      categorySliderTrack.appendChild(categorySliderList);
      categorySlider.appendChild(categorySliderTrack);
      category.insertAdjacentElement('afterbegin', categorySlider);

      new Splide(categorySlider, {
        type: 'loop',
        perPage: 6,
        perMove: 1,
        pagination: false,
        autoScroll: {
          speed: 0.5,
        },
        breakpoints: {
          768: {
            perPage: 3,
          },
        },
      }).mount({ AutoScroll });
    }
  });
})();

// Function to add "Shop All" link to tier two categories
(() => {
  const tierTwoCategories = document.querySelectorAll('.cd-dropdown-content .cd-secondary-dropdown > li:not(.go-back):not(.has-html):not(.has-image)');
  if (!tierTwoCategories.length > 0) return;

  tierTwoCategories.forEach((category) => {
    const link = category?.querySelector(':scope > a')?.getAttribute('href');
    const shopAll = document.createElement('li');
    shopAll.classList.add('shop-all');
    shopAll.innerHTML = `<a href="${link}">Shop All <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 24 24" viewBox="-3.45 -3.45 30.9 30.9" width="9" height="9"><path d="m12 21.4 9.4-9.4L12 2.6M2.6 12h18.8" style="fill:none;stroke:#6d6d6e;stroke-width:5;stroke-linecap:round;stroke-linejoin:round"></path></svg></a>`;

    category.querySelector('ul').insertAdjacentElement('beforeend', shopAll);
  });
})();

// moving ink & toner finder from footer to menu
(() => {
  const inkTonerFinder = document.querySelector('.footer-finder');
  if (!inkTonerFinder) return;

  inkTonerFinder.classList = '';

  const target = document.querySelector('.menu-inktoner-wrap');
  if (!target) {
    inkTonerFinder.remove();
    return;
  } target.insertAdjacentElement('beforeend', inkTonerFinder);

  const finderMenu = document.querySelector('.header-full .menu-finder');
  finderMenu.addEventListener('mouseover', () => {
    finderMenu.querySelector('.cd-secondary-dropdown').classList.add('active');
  });

  const menucats = document.querySelectorAll('.header-full .cd-dropdown-content > li:not(.go-back-mobile):not(.menu-finder)');
  menucats.forEach((menucat) => {
    menucat.addEventListener('mouseout', () => {
      finderMenu.querySelector('.cd-secondary-dropdown').classList.remove('active');
    });
  });
})();

// moving brands from footer to menu
(() => {
  const brands = document.querySelector('.footer-brands');
  if (!brands) return;

  brands.classList = '';

  const target = document.querySelector('.menu-brands-wrap');
  if (!target) {
    brands.remove();
    return;
  }

  target.insertAdjacentElement('beforeend', brands);
})();

/**
 * move any additional linkslist items into menu
 * This is due to contract items which is added dynamically into additional linkslist
 */
(() => {
  const additionalLinkslist = document.querySelectorAll('header .header-full .headermenu_container .additional_linkslist > li');
  const horMenu = document.querySelector('header .header-full .menulinks_container .horizontal-nav > ul');
  if (!horMenu) return;
  additionalLinkslist.forEach((item) => {
    horMenu.prepend(item);
  });
})();
